<app-bottom-sheet
  [isOpen]="isOpen"
  [leftButtonText]="mode === 'selection' ? leftButtonText : 'Cancel'"
  [rightButtonText]="mode === 'selection' ? (rightButtonText + (selectedFiltersCount > 0 ? ' (' + selectedFiltersCount + ')' : '')) : 'Select'"
  [leftButtonDisabled]="mode === 'selection' ? selectedFiltersCount === 0 : false"
  [rightButtonDisabled]="mode === 'configuration' ? isSelectButtonDisabled : isApplyButtonDisabled"
  [preventOverlayClose]="true"
  [headerTemplate]="mode === 'selection' ? filterHeaderTemplate : filterConfigHeaderTemplate"
  [contentTemplate]="mode === 'selection' ? filterContentTemplate : filterConfigContentTemplate"
  (isOpenChange)="onFilterDrawerClose()"
  (leftButtonClick)="mode === 'selection' ? onFilterClearAll() : onCancel()"
  (rightButtonClick)="mode === 'selection' ? onFilterApply() : onSelect()"
  data-testid="filter-bottom-sheet">
</app-bottom-sheet>

<ng-template #filterHeaderTemplate>
  <div class="filter-header-content" data-testid="filter-header-content">
    <button 
      class="close-icon-btn" 
      (click)="onCloseIconClick()"
      data-testid="close-icon-btn"
      aria-label="Close"
      type="button">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
    <h2 class="filter-title" data-testid="filter-title" id="filter-title">Filter By</h2>
  </div>
</ng-template>

<ng-template #filterContentTemplate>
  <div class="filter-content" data-testid="filter-content">
    <div class="filter-options-container" data-testid="filter-options-container">
      @for (option of FilterCategories; track option.id) {
        <div class="filter-option"
             [class.first-option]="$first"
             [attr.data-testid]="'filter-option-' + option.id"
             (click)="onFilterCategoryClick(option)"
             role="button"
             tabindex="0"
             [attr.aria-label]="'Configure ' + option.label + ' filter'">
          <div class="filter-option-content">
            <div class="filter-option-header">
              <span class="filter-option-text" data-testid="filter-option-text">{{ option.label }}</span>
              <i class="pi pi-chevron-right filter-option-chevron"
                 data-testid="filter-option-chevron"
                 aria-hidden="true"></i>
            </div>
            @if (option.id === 'trade-partner' && shouldShowNoVendorsText) {
              <span class="filter-option-subtext" data-testid="filter-option-subtext">
                {{ noVendorsText }}
              </span>
            }
          </div>
        </div>
      }
    </div>

    <div class="selected-filters-section" data-testid="selected-filters-section" role="region" aria-label="Selected filters">
      <h3 class="selected-filters-title" data-testid="selected-filters-title">Selected Filters</h3>
      
      @if (selectedFiltersDisplay['trade-partner'].length > 0 || selectedFiltersDisplay['room'].length > 0 || selectedFiltersDisplay['status'].length > 0 || selectedFiltersDisplay['bq-step'].length > 0) {
        <div class="selected-filters-pills" [attr.data-testid]="'selected-filters-pills'" role="list" [attr.aria-label]="'Selected filters list'">
          <!-- Trade Partners -->
          @if (selectedFiltersDisplay['trade-partner'].length > 0) {
            <div class="filter-group" [attr.data-testid]="'trade-partner-pills'" role="group" aria-label="Trade partner filters">
              @for (pill of selectedFiltersDisplay['trade-partner']; track pill.id) {
                <div class="filter-pill" [attr.data-testid]="'filter-pill-' + pill.id" role="listitem">
                  <span class="pill-text">{{ pill.label | titlecase }}</span>
                  <button 
                    class="pill-remove-btn" 
                    (click)="onRemoveFilterPill(pill.type, pill.id)"
                    [attr.data-testid]="'remove-pill-' + pill.id"
                    [attr.aria-label]="'Remove ' + pill.label + ' filter'">
                    <i class="pi pi-times" aria-hidden="true"></i>
                  </button>
                </div>
              }
            </div>
          }

          <!-- Rooms -->
          @if (selectedFiltersDisplay['room'].length > 0) {
            <div class="filter-group" [attr.data-testid]="'room-pills'" role="group" aria-label="Room filters">
              @for (pill of selectedFiltersDisplay['room']; track pill.id) {
                <div class="filter-pill" [attr.data-testid]="'filter-pill-' + pill.id" role="listitem">
                  <span class="pill-text">{{ pill.label }}</span>
                  <button 
                    class="pill-remove-btn" 
                    (click)="onRemoveFilterPill(pill.type, pill.id)"
                    [attr.data-testid]="'remove-pill-' + pill.id"
                    [attr.aria-label]="'Remove ' + pill.label + ' filter'">
                    <i class="pi pi-times" aria-hidden="true"></i>
                  </button>
                </div>
              }
            </div>
          }

          <!-- Status -->
          @if (selectedFiltersDisplay['status'].length > 0) {
            <div class="filter-group" [attr.data-testid]="'status-pills'" role="group" aria-label="Status filters">
              @for (pill of selectedFiltersDisplay['status']; track pill.id) {
                <div class="filter-pill" [attr.data-testid]="'filter-pill-' + pill.id" role="listitem">
                  <span class="pill-text">{{ pill.label }}</span>
                  <button 
                    class="pill-remove-btn" 
                    (click)="onRemoveFilterPill(pill.type, pill.id)"
                    [attr.data-testid]="'remove-pill-' + pill.id"
                    [attr.aria-label]="'Remove ' + pill.label + ' filter'">
                    <i class="pi pi-times" aria-hidden="true"></i>
                  </button>
                </div>
              }
            </div>
          }

          <!-- bq step -->
          @if (selectedFiltersDisplay['bq-step'].length > 0) {
            <div class="filter-group" [attr.data-testid]="'bq-step-pills'" role="group" aria-label="Status filters">
              @for (pill of selectedFiltersDisplay['bq-step']; track pill.id) {
                <div class="filter-pill" [attr.data-testid]="'filter-pill-' + pill.id" role="listitem">
                  <span class="pill-text">{{ pill.label }}</span>
                  <button 
                    class="pill-remove-btn" 
                    (click)="onRemoveFilterPill(pill.type, pill.id)"
                    [attr.data-testid]="'remove-pill-' + pill.id"
                    [attr.aria-label]="'Remove ' + pill.label + ' filter'">
                    <i class="pi pi-times" aria-hidden="true"></i>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <p class="selected-filters-subtitle" [attr.data-testid]="'selected-filters-subtitle'" aria-live="polite">
          No filters selected yet
        </p>
      }
    </div>
  </div>
</ng-template>

<!-- Configuration Mode Header -->
<ng-template #filterConfigHeaderTemplate>
  <div class="filter-config-header-content" data-testid="filter-config-header-content">
    <h2 class="filter-config-title" data-testid="filter-config-title" id="filter-config-title">
      {{ currentFilterType || 'Filter' }}
    </h2>
  </div>
</ng-template>

<!-- Configuration Mode Content -->
<ng-template #filterConfigContentTemplate>
  <div class="filter-config-content" data-testid="filter-config-content">
    <div class="filter-values-container" data-testid="filter-values-container">
      @for (value of filterValues; track value.id) {
        <div class="filter-value-option"
             [class.selected]="value.selected"
             [attr.data-testid]="'filter-value-option-' + value.id"
             (click)="onFilterValueToggle(value)"
             role="checkbox"
             tabindex="0"
             [attr.aria-checked]="value.selected"
             [attr.aria-label]="(value.label | titlecase) + ' filter option'">
          <div class="checkbox-container">
            <input 
              type="checkbox" 
              [checked]="value.selected"
              [attr.data-testid]="'filter-value-checkbox-' + value.id"
              class="filter-value-checkbox">
            @if (currentFilterType === 'BQ Step') {
              <span class="filter-value-text" data-testid="filter-value-text">{{ value.label }}</span>
            } @else {
              <span class="filter-value-text" data-testid="filter-value-text">{{ value.label | titlecase }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
